import { ColumnType, Pinned, TableDefinition } from '@vendasta/va-filter2-table';
import { PackageNameCellComponent } from './cells/package-name-cell.component';
import { PackageRevenueCellComponent } from './cells/package-revenue-cell.component';
import { PackageRevenueHeaderCellComponent } from './cells/package-revenue-header-cell.component';
import { PackageSelectorService } from './package-selector.service';
import { PackageWithPrice } from './package-with-price';

const PACKAGE_SELECTOR_TABLE_DEF: TableDefinition = {
  id: 'package-selector',
  labels: {
    noResults: 'No results',
    cancel: 'Cancel',
    none: 'None',
    update: 'Update',
    sortBy: 'Sort By',
    thenSortBy: 'Then Sort By',
    addAnotherSortColumn: 'Add another column to sort on',
    chooseColumnToSortBy: 'Choose a column to sort on',
    columnSorting: {
      date: {
        ascending: 'Earliest first',
        descending: 'Latest first',
      },
      number: {
        ascending: '1 to 9',
        descending: '9 to 1',
      },
      string: {
        ascending: 'A to Z',
        descending: 'Z to A',
      },
      default: {
        ascending: 'ascending',
        descending: 'descending',
      },
    },
    export: {
      buttonText: 'Export',
      buttonTooltipBeforeCount: 'Export',
      buttonTooltipAfterCount: 'items',
    },
  },
  options: {
    selectableRows: true,
  },
  columns: [
    {
      id: 'name',
      displayName: 'FRONTEND.SALES_UI.NAME',
      field: 'name',
      pinned: Pinned.PINNED_LEFT,
      type: ColumnType.COLUMN_TYPE_STRING,
      cellComponent: PackageNameCellComponent,
    },
    {
      id: 'retail-price',
      displayName: 'FRONTEND.SALES_UI.RETAIL_PRICE',
      field: 'name',
      cellComponent: PackageRevenueCellComponent,
      headerComponent: PackageRevenueHeaderCellComponent,
    },
  ],
  rowEqualityFunc: (row1: PackageWithPrice, row2: PackageWithPrice) =>
    row1.package.packageId === row2.package.packageId,
};

export const tableDefinitionFactory = (packageSelectorService: PackageSelectorService) => {
  const tableDefinition = PACKAGE_SELECTOR_TABLE_DEF;
  tableDefinition.filters = packageSelectorService.filters;
  return tableDefinition;
};
